export default "__VITE_ASSET__IELlATcp__"